import type { EmbeddedWorkspaceSeed } from '../stores/workspace';

export type DockMessage =
  | { type: 'chronis-dock-request-seed'; workspaceId: string }
  | { type: 'chronis-dock-seed'; workspaceId: string; seed: EmbeddedWorkspaceSeed }
  | { type: 'chronis-dock-open-entity'; workspaceId: string; entityId: string };

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Accept messages only from the explicitly paired same-origin window. */
export function readDockMessage(event: MessageEvent, origin: string, source: Window | null): DockMessage | null {
  if (!source || event.origin !== origin || event.source !== source || !event.data || typeof event.data !== 'object') return null;
  const data = event.data as Record<string, unknown>;
  if (typeof data.workspaceId !== 'string' || !uuid.test(data.workspaceId)) return null;
  if (data.type === 'chronis-dock-request-seed') return { type: data.type, workspaceId: data.workspaceId };
  if (data.type === 'chronis-dock-open-entity') {
    return typeof data.entityId === 'string' && uuid.test(data.entityId)
      ? { type: data.type, workspaceId: data.workspaceId, entityId: data.entityId } : null;
  }
  if (data.type === 'chronis-dock-seed') {
    const seed = data.seed as EmbeddedWorkspaceSeed | null;
    return seed?.workspace?.id === data.workspaceId ? { type: data.type, workspaceId: data.workspaceId, seed } : null;
  }
  return null;
}
